export default "__VITE_ASSET__cb650ba1__"